import { Box, Card, Typography, Button } from "@mui/material";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOffAltOutlinedIcon from "@mui/icons-material/ThumbDownOffAltOutlined";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import useThemeRender from "../../theme/useThemeRender";
import CommonShareButton from "../LinkScreen/CommonShareButton";
import { useState } from "react";
import ForumSubDetailPage from "./ForumSubDetailPage";
import "./FritoForumDetailPage.css";

const ForumSummaryCard = ({
  isLiked,
  isDisliked,
  onLike,
  onDislike,
  onShare,

  data,
}) => {
  const backgroundColorLayer3 = useThemeRender("backgroundColorLayer3");
  const backgroundColorLayer1 = useThemeRender("backgroundColorLayer1");
  const textColorLayer2 = useThemeRender("textColorLayer2");
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
  });
  const handleClose = () => {
    setState({ ...state, open: false });
  };
  const { vertical, horizontal, open } = state;
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "16px",
        width: "100%",
      }}
    >
      <Card
        className="SummaryCard"
        sx={{
          background: backgroundColorLayer3,
          width: "100%",
        }}
      >
        <Typography
          className="SummaryTitle"
          sx={{
            color: textColorLayer2,
            fontSize: "25px !important",
          }}
        >
          {data?.title}
        </Typography>
        <Box
          className="SummaryContentBox"
          sx={{
            background: backgroundColorLayer1,
          }}
        >
          <Typography
            className="ForumSummaryContents"
            sx={{
              color: textColorLayer2,
              width: {
                xs: "100%",
                md: "80%",
              },
              padding: "12px",
            }}
          >
            {data?.description}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            alignSelf: "stretch",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "var(--Spacing-spacing-16, 16px)",
              flexWrap: "wrap",
            }}
          >
            <CommonShareButton
              onClick={onShare}
              vertical={vertical}
              horizontal={horizontal}
              open={open}
              onClose={handleClose}
            />
            <Box
              sx={{
                display: "flex",
                height: "var(--Spacing-spacing-32, 32px)",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button
                className="LogoButton"
                onClick={onLike}
                data-testid="like-button"
              >
                <Typography className="LogoContent">Like</Typography>
                {isLiked ? (
                  <ThumbUpIcon
                    style={{
                      color: "#005CBC",
                      cursor: "pointer",
                      width: "20px",
                      height: "20px",
                    }}
                  />
                ) : (
                  <ThumbUpOutlinedIcon
                    style={{
                      color: "#005CBC",
                      cursor: "pointer",
                      width: "20px",
                      height: "20px",
                    }}
                  />
                )}
              </Button>
            </Box>
            <Box
              sx={{
                display: "flex",
                height: "var(--Spacing-spacing-32, 32px)",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button className="LogoButton" onClick={onDislike}>
                <Typography className="LogoContent">Dislike</Typography>
                {isDisliked ? (
                  <ThumbDownAltIcon
                    style={{
                      color: "#005CBC",
                      cursor: "pointer",
                      width: "20px",
                      height: "20px",
                    }}
                  />
                ) : (
                  <ThumbDownOffAltOutlinedIcon
                    style={{
                      color: "#005CBC",
                      cursor: "pointer",
                      width: "20px",
                      height: "20px",
                    }}
                  />
                )}
              </Button>
            </Box>
          </Box>
        </Box>
        <Typography
          className="SummaryTitle"
          sx={{
            color: textColorLayer2,
            fontSize: "25px !important",
          }}
        >
          Details
        </Typography>
        <ForumSubDetailPage data={data} />
        <Typography
          className="SummaryTitle"
          sx={{
            color: textColorLayer2,
            fontSize: "25px !important",
          }}
        >
          Disclaimer
        </Typography>
        <Box
          className="SummaryContentBox"
          sx={{
            background: backgroundColorLayer1,
            padding: "12px",
          }}
        >
          <Typography
            className="ForumSummaryContents"
            sx={{
              color: textColorLayer2,
              width: {
                xs: "100%",
                md: "80%",
              },
            }}
          >
            {data?.disclaimerText}
          </Typography>
        </Box>
      </Card>
    </Box>
  );
};

export default ForumSummaryCard;
